import { service } from '@ember/service';
import Route from '@ember/routing/route';

export default class SiteWaitlistIntakeRoute extends Route {
  @service currentPractice;
  @service router;
  @service session;

  beforeModel() {
    super.beforeModel(...arguments);

    if (
      this.session.currentClient ||
      !this.currentPractice.get('isNewClientAllowedToJoinWaitlist')
    ) {
      return this.router.transitionTo('site.home');
    }
  }
}
